import ObjectUtil from './ObjectUtil.js';
import DateUtil from './DateUtil.js';

/**
 * 定义工具类方法
 */
const install = function(Vue, options) {
    Vue.prototype.$ObjectUtil = ObjectUtil;
    Vue.prototype.$DateUtil = DateUtil;
}
export default install;